export { default } from './index.vue';


// WEBPACK FOOTER //
// ./packages/wxc-special-rich-text/index.js